import env from "@/env";
import { get } from "@/utils/request";

/**
 * 获取隐私协议
 * @returns
 */
export const queryConfigAgreement = () => {
  return get<{ [key: string]: { content: string } }>({
    baseURL: env.centerUrl,
    url: "/ddd/basic/queryConfigAgreement",
  });
};
